import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mb-5" }
const _hoisted_2 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DialogOrderDetail = _resolveComponent("DialogOrderDetail")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      title: _ctx.titleDialog,
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      class: "bg-light rounded",
      onOpen: _ctx.onOpen,
      onClosed: _ctx.onClosed,
      "close-on-click-modal": false,
      "lock-scroll": "",
      draggable: "",
      "destroy-on-close": "",
      top: "2vh",
      fullscreen: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            placeholder: "Ingrese número de Orden",
            class: "w-400px"
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _ctx.generarOrder
          }, {
            default: _withCtx(() => [
              _createTextVNode("Agregar orden")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.listOrders,
          border: "",
          "table-layout": 'auto',
          "scrollbar-always-on": true,
          "highlight-current-row": "",
          height: _ctx.altura
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "idorder",
              label: "ID",
              width: "80",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "order_number",
              label: _ctx.t('Orden')
            }, {
              default: _withCtx(( {row} ) => [
                _createElementVNode("span", null, _toDisplayString(row.idserie) + "-" + _toDisplayString(row.idcorrelative), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "customer",
              label: _ctx.t('Institucion')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "quantity",
              label: _ctx.t('Cantidad')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "import",
              label: _ctx.t('Importe')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: _ctx.t('registered')
            }, {
              default: _withCtx(( {row} ) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.created_at).format("DD/MM/YYYY HH:mm:ss")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "mstatus",
              label: _ctx.t('state')
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(row?.mstatus.params)
                }, _toDisplayString(row?.mstatus?.name), 3)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              width: "120",
              label: _ctx.t('options'),
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: 'Ejecutar cobro',
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("i", {
                        class: "bi bi-paypal fs-2 text-hover-primary me-3 cursor-pointer",
                        key: row.idorder,
                        onClick: _cache[0] || (_cache[0] = ()=>{})
                      }))
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "height"])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onOpen", "onClosed"]),
    _createVNode(_component_DialogOrderDetail, {
      ref: "DialogOrderDetailRef",
      "item-order": null
    }, null, 512)
  ], 64))
}